module.exports = __webpack_public_path__ + "img/m_About.e77fc385.png";